import type { SettingsFormState } from '../../types'

/** Baseline snapshot after load or successful save (profile settings page). */
export interface ProfileSettingsInitialValues {
  displayName: string
  bio: string
  location: string
  birthday: string
  profileVisibility: string
  locationVisibility: string
  birthdayVisibility: string
  memberSinceVisibility: string
  bioVisibility: string
  topicsVisibility: string
  archetypesVisibility: string
  journeyStageVisibility: string
  centerContentIds: string
  archetype: string
  journeyStage: string
}

export function isProfileSettingsDirty (
  fs: SettingsFormState,
  iv: ProfileSettingsInitialValues | null,
): boolean {
  if (!iv) return false
  const sortedTags = fs.selectedTagIds.slice().sort().join(',')
  const sortedArchetypes = fs.selectedArchetypes.slice().sort().join(',')
  return fs.displayName !== iv.displayName
    || fs.bio !== iv.bio
    || fs.locationValue !== iv.location
    || fs.birthdayValue !== iv.birthday
    || fs.profileVisibility !== iv.profileVisibility
    || fs.birthdayVisibility !== iv.birthdayVisibility
    || fs.memberSinceVisibility !== iv.memberSinceVisibility
    || fs.bioVisibility !== iv.bioVisibility
    || fs.topicsVisibility !== iv.topicsVisibility
    || fs.archetypesVisibility !== iv.archetypesVisibility
    || fs.journeyStageVisibility !== iv.journeyStageVisibility
    || fs.locationVisibility !== iv.locationVisibility
    || sortedTags !== iv.centerContentIds
    || sortedArchetypes !== iv.archetype
    || (fs.journeyStage || '') !== iv.journeyStage
}
